import React from "react";
import { useNav } from "../customHooks/useNav";
import headshot from "../img/willemdatema.webp";
import "./Page.css";

const Home = () => {
  const homeRef = useNav("Home");

  return (
    <section ref={homeRef} id="homeContainer" className="hero">
      <div className="hero-media">
        <div className="hero-media-dot"></div>
        <div className="hero-media-frame">
          <img src={headshot} alt="Willem Datema" />
        </div>
      </div>
      <div className="section-inner hero-inner">
        <div className="hero-content">
          <div className="hero-kicker">
            <span className="hero-kicker-line"></span>
            <span>Scientist Data Sharing Infrastructures · Utrecht</span>
          </div>
          <h1 className="hero-title">
            Willem
            <br />
            Datema
          </h1>
          <div className="hero-divider"></div>
          <div className="hero-actions">
            <a href="#contactContainer" className="btn btn-primary">
              Neem contact op
            </a>
            <a
              href="https://github.com/Willeem"
              target="_blank"
              rel="noreferrer"
              className="btn btn-ghost"
            >
              GitHub →
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Home;
